// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__zKjOF","pageSize":"Paginate_pageSize__3kLqG"};